import { Chip } from "@mui/material";
import { Datagrid, DateField, FunctionField, List, TextField } from "react-admin";

import { orderStatus } from "./status";

export function OrderList() {
  return (
    <List perPage={25} sort={{ field: "created_at", order: "DESC" }} exporter={false}>
      <Datagrid bulkActionButtons={false} rowClick="show">
        <TextField source="reference" label="Заявка" sx={{ fontFamily: "monospace" }} />
        <FunctionField
          label="Статус"
          render={(r: { status: string }) => {
            const s = orderStatus(r.status);
            return <Chip size="small" color={s.color} label={s.label} />;
          }}
        />
        <FunctionField label="Сумма ₽" render={(r: { amount_rub: number }) => r.amount_rub.toLocaleString("ru-RU")} />
        <FunctionField label="USD" render={(r: { amount_usdt: number }) => r.amount_usdt.toFixed(2)} />
        <FunctionField label="Курс" render={(r: { rate: number }) => r.rate.toFixed(2)} />
        <FunctionField
          label="cid"
          render={(r: { broker_client_id: number | null }) => (r.broker_client_id != null ? String(r.broker_client_id) : "—")}
        />
        <TextField source="user_phone" label="Телефон" />
        <TextField source="wallet_address" label="Кошелёк" sx={{ fontFamily: "monospace", fontSize: 11 }} />
        <DateField source="created_at" label="Создана" showTime />
      </Datagrid>
    </List>
  );
}
